/* eslint-disable no-param-reassign */
import {
  CLEAR_IS_USER_CHECK, FETCH_ERROR, FETCH_RESET, FETCH_START, FETCH_SUCCESS, HIDE_MESSAGE, SHOW_MESSAGE
} from 'src/constants/ActionTypes';

const INIT_STATE = {
  error: '',
  loading: false,
  message: '',
  data: [],
  item: []
};

export default (state = INIT_STATE, action) => {
  const { getName, apiType, type } = action;
  switch (type) {
    case FETCH_START: {
      if (getName) {
        return {
          ...state,
          [getName]: {
            ...state[getName],
            loading: true
          }
        };
      }
      return {
        ...state,
        loading: true
      };
    }
    case FETCH_SUCCESS: {
      if (apiType === 'LIST' || apiType === 'ADD' || apiType === 'DELETE' || apiType === 'EDIT') {
        if (getName) {
          return {
            ...state,
            [getName]: {
              ...state[getName], data: action.data, loading: false
            }
          };
        }
        return {
          ...state, data: action.data, loading: false
        };
      }
      if (apiType === 'DETAIL') {
        if (getName) {
          return {
            ...state,
            [getName]: {
              ...state[getName], item: action.data, loading: false
            }
          };
        }
        return {
          ...state, item: action.data, loading: false
        };
      }
      if (apiType === 'SEND' || apiType === 'NOTMESSAGE' || apiType === 'APPROVED') {
        if (getName) {
          return {
            ...state,
            [getName]: {
              ...state[getName], loading: false
            }
          };
        }
        return {
          ...state, loading: false
        };
      }
      return { ...state };
    }
    case FETCH_ERROR: {
      if (getName) {
        return {
          ...state,
          [getName]: {
            ...state[getName], error: action.error, loading: false
          }
        };
      }
      return {
        ...state, error: action.error, loading: false
      };
    }
    case CLEAR_IS_USER_CHECK:
      if (getName) {
        return {
          ...state,
          [getName]: {
            ...state[getName], error: action.payload, loading: false
          }
        };
      }
      return {
        ...state, error: action.payload, loading: false
      };
    case SHOW_MESSAGE: {
      if (getName) {
        return {
          ...state,
          [getName]: {
            ...state[getName], message: action.payload, loading: false
          }
        };
      }
      return {
        ...state, message: action.payload, loading: false
      };
    }
    case HIDE_MESSAGE: {
      if (getName) {
        return {
          ...state,
          [getName]: {
            ...state[getName], loading: false
          }
        };
      }
      return {
        ...state, loading: false
      };
    }
    case FETCH_RESET: {
      if (getName) {
        return {
          ...state,
          [getName]: {
            ...state[getName], ...INIT_STATE
          }
        };
      }
      return INIT_STATE;
    }
    default:
      return state;
  }
};
